import { PageSlugs } from "../../../add-element/types";
import { IsPreviewOrDemoProvider } from "../../../contexts/IsPreviewOrDemoContext";
import { useCurrentSite } from "../../../contexts/models/SiteContext";
import { withInvalidRouteRedirect } from "../../../core/routing";
import { RootState } from "../../../resources/reduxTypes";
import { getAllResources, getResource, filterPage } from "../../selectors";
import FancyClothesProvider from "../FancyClothesProvider";
import Footer from "../Footer";
import WebsiteHeader from "../WebsiteHeader";
import WebsitePages from "../WebsitePages";
import OnlineInvitationRSVPButton from "./OnlineInvitationRSVPButton";
import { css, Global } from "@emotion/react";
import {
  GlobalStyles,
  theme,
  useMediaQueryState,
} from "@minted/minted-components";
import React, { memo } from "react";
import { useSelector } from "react-redux";

const stickyButtonPadding = css`
  margin-bottom: ${theme.spacing.x8};
`;

const OnlineInvitationSite = () => {
  const site = useCurrentSite();
  const pages = useSelector((state: RootState) =>
    getResource(state.resources.pages),
  );
  const events = useSelector((state: RootState) =>
    getResource(state.resources.events),
  );
  const resources = useSelector((state: RootState) =>
    getAllResources(state.resources),
  );
  const themeAuthor = useSelector(
    (state: RootState) => state.theme.attribution,
  );

  const mediumMediaQueryState = useMediaQueryState({
    mediaQuerySize: "medium",
  });

  const isMobile = mediumMediaQueryState === "BELOW";
  const filteredPages = pages.filter((page) =>
    filterPage(page, {
      ...resources,
      sites: [site],
    }),
  );

  const customCssElement = site.extraCss ? (
    <Global
      styles={css`
        ${site.extraCss}
      `}
    />
  ) : null;

  return (
    <FancyClothesProvider>
      <GlobalStyles />
      {customCssElement}
      <IsPreviewOrDemoProvider
        isDemo={Boolean(site.isDemoSite)}
        isPreview={false}
      >
        <div id="home">
          <WebsiteHeader condensed={false} pages={filteredPages} />
        </div>
        <WebsitePages
          pages={filteredPages}
          resources={resources}
          site={site}
          source="website"
        />
        <OnlineInvitationRSVPButton event={events[0]} site={site} />
        <Footer artist={themeAuthor} />
        {isMobile && <div css={stickyButtonPadding} />}
      </IsPreviewOrDemoProvider>
    </FancyClothesProvider>
  );
};

const MemoizedOnlineInvitationSite = memo(OnlineInvitationSite);

// Apply route redirect handling
export default withInvalidRouteRedirect(MemoizedOnlineInvitationSite, {
  redirectTo: PageSlugs.Root,
});
